<template>
  <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <HeadlineComponent :subtitle="`Insgesamt: ${webhooks.length}`"
    >Webhooks</HeadlineComponent
  >
  <div class="webhooks">
    <template v-for="webhook of webhooks" :key="webhook.id">
      <div class="webhook mb-4">
        <div>
          <span>{{ webhook.name }}</span>
        </div>
        <div>
          <RouterLink
            :to="`/settings/webhook/${webhook.id}`"
            class="btn btn-primary btn-sm mt-2"
            >Bearbeiten <span class="fa fa-pencil"></span
          ></RouterLink>
          <LoadingButton
            @click="remove(webhook)"
            class="btn-danger btn-sm mt-2"
            :loading="webhook.loading"
          >
            Löschen <span class="fa fa-remove"></span>
          </LoadingButton>
        </div>
      </div>
      <hr class="mb-4 volunteer-hr" />
    </template>
  </div>

  <h2>Neuen Webhook anlegen</h2>
  <Form class="form-horizontal" @submit="create">
    <div class="form-group">
      <BootstrapField
        type="text"
        placeholder="Name"
        name="name"
        rules="required"
      />
    </div>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading"
        >Hinzufügen</LoadingButton
      >
    </div>
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import webhookService from "@/services/webhook.service.js";
import router from "@/router/index.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { Form } from "vee-validate";
import BootstrapField from "@/components/BootstrapField.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "WebhooksView",
  components: {
    HeadlineComponent,
    ConfirmModal,
    LoadingButton,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    BootstrapField,
  },
  data() {
    return {
      webhooks: [],
      name: "",
      loading: false,
    };
  },
  async beforeMount() {
    try {
      let response = await webhookService.index();
      this.webhooks = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async create(form, actions) {
      this.loading = true;
      try {
        let response = await webhookService.create({ name: form.name });
        router.push(`/settings/webhook/${response.data.id}`);
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
            this.loading = false;
            return;
          }
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
        this.loading = false;
      }
    },
    async remove(webhook) {
      webhook.loading = true;
      if (
        await this.$refs.confirmModal.show(
          "Webhook löschen",
          `Soll der Webhook ${webhook.name} wirklich gelöscht werden?`
        )
      ) {
        try {
          await webhookService.remove(webhook.id);
          for (let i = 0; i < this.webhooks.length; i++) {
            if (this.webhooks[i].id === webhook.id) {
              this.webhooks.splice(i, 1);
              break;
            }
          }
        } catch (e) {
          if (e) {
            this.addAlert(
              "danger",
              "Es ist was unerwartetes schief gegangen.."
            );
            window.scrollTo(0, 0);
          }
        }
      }
      webhook.loading = false;
    },
  },
};
</script>

<style scoped></style>
